module.exports = __webpack_public_path__ + "media/audio25.351a30a3.mp3";